import {typeList} from '../product/productManage'

//结论
export const resultType = [
	{value: 1, label: '可投保'},
	{value: 2, label: '无对应职业'},
	{value: 3, label: '拒保'},
]

export const tableOption = {
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	delBtn: false,
	addBtn: false,
	emptyBtn: false,
	searchBtn: false,
	// menu: false,
	editBtn: false,
	menuAlign: 'center',
	refreshBtn: false,
	columnBtn: false,
	searchShowBtn: false,

	align: 'center',
	searchMenuPosition: 'right',
	searchMenuSpan: 18,
	labelWidth: 120,
	column: [
		{
			label: '产品',
			prop: 'insuranceId',
			type: 'select',
			dicUrl: '/dist/distProduct/filterProduct/list',
			props: {
				label: 'abbreviation',
				value: 'type',
			},
		},
		{
			label: '是否可投保',
			prop: 'result',
		},
		{
			label: '适用方案',
			prop: 'suitProduct',
			type: 'select',
			// dicUrl: `/dist/distProduct/listInfo`,
			props: {
				label: 'title',
				value: 'id',
			},
			// dicFormatter: function ({ data }) {
			//   return [{ title: "全部", id: "-1" }, ...data];
			// },
		},

		{
			label: '工种',
			prop: 'suitWork',
		},
		{
			label: '备注',
			prop: 'remark',
		},
	],
}

export const gzhcTableOption = {
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	delBtn: false,
	addBtn: false,
	emptyBtn: false,
	searchBtn: false,
	// menu: false,
	editBtn: false,
	menuAlign: 'center',
	refreshBtn: false,
	columnBtn: false,
	searchShowBtn: false,
	grid: true,
	gridSpan: 12,
	menuWidth: 300,
	align: 'center',
	searchMenuPosition: 'right',
	searchMenuSpan: 18,
	labelWidth: 120,
	column: [
		{
			label: '可投保产品',
			prop: 'pubName',
			gridRow: true,
			formatter: ({productInfo}) => {
				return productInfo.pubName || ''
			},
		},
		{
			label: '可投保职业',
			gridRow: true,
			prop: 'professionsStr',
			html: true,
		},
	],
}
export const bannedAreaOption = {
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	delBtn: false,
	addBtn: false,
	emptyBtn: false,
	// menu: false,
	editBtn: false,
	menuAlign: 'center',
	refreshBtn: false,
	columnBtn: false,
	searchShowBtn: false,
	searchLabelWidth: 100,
	align: 'center',
	searchGutter: 12,
	menuWidth: 300,
	searchMenuPosition: 'right',
	searchMenuSpan: 12,
	column: [
		{
			label: '企业归属地',
			type: 'cascader',
			prop: 'areaCode',
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			dicUrl: `/dist/area/list/3`,
			dicMethod: 'get',
			filterable: true,
			searchRules: [
				{
					required: true,
					message: '请选择企业归属地',
					trigger: 'blur',
				},
			],
			showAllLevels: true,
			search: true,
			hide: true,
			showColumn: false,
		},
		{
			label: '投保产品类型',
			prop: 'type',
			dicData: typeList,
			type: 'select',
			search: true,
			hide: true,
			showColumn: false,
		},

		{
			label: '产品名称',
			prop: 'productName',
		},
		{
			label: '结论',
			prop: 'isInsurable',
			type: 'select',
			dicData: [
				{
					label: '可投保',
					value: '1',
				},
				{
					label: '拒保',
					value: '0',
				},
			],
		},

		{
			label: '可投保方案',
			prop: 'planName',
		},
		{
			label: '可投保限额',
			prop: 'amounts',
			formatter: ({amounts}) => {
				let str = ''
				if (amounts && amounts.length > 0) {
					str = amounts.map((item) => `${parseInt(item)}万`).join(',')
				}
				return str || '—'
			},
		},
		{
			label: '可投保期限',
			prop: 'terms',
			formatter: ({terms}) => {
				let str = ''
				if (
					terms &&
					terms.length > 0 &&
					(terms.findIndex((item) => item == 12) != -1 || terms.findIndex((item) => item == 0) != -1)
				) {
					str += '一年'
				}
				if (
					terms &&
					terms.length > 0 &&
					!(terms.findIndex((item) => item == 12) != -1 || terms.findIndex((item) => item == 0) != -1)
				) {
					str += str ? ',小于一年' : '小于一年'
				}
				return str || '—'
			},
		},
	],
}

//工种库
export const verification = (safe) => {
	return {
		border: true,
		// stripe: true,
		delBtn: false,
		addBtn: false,
		editBtn: false,
		menuAlign: 'center',
		align: 'center',
		searchMenuPosition: 'right',
		searchMenuSpan: 6,
		labelWidth: 120,
		menuWidth: 100,
		searchLabelWidth: 130,
		column: [
			{
				label: '职业关键字',
				prop: 'keyWord',
				search: true,
			},
			{
				label: '作业条件1',
				prop: 'condition1',
			},
			{
				label: '作业条件2',
				prop: 'condition2',
			},
			{
				label: '作业条件3',
				prop: 'condition3',
			},

			{
				label: '险种&结论&工种&适用产品&备注',
				prop: 'inReSuitWork',
				headerslot: true,
				width: 900,
			},

			{
				label: '结论',
				hide: true,
				showColumn: false,
				prop: 'result',
			},
			{
				label: '工种',
				hide: true,
				showColumn: false,
				prop: 'suitWork',
				search: true,
			},
			{
				label: '险种',
				prop: 'insuranceId',
				hide: true,
				showColumn: false,
				type: 'select',
				dicUrl: '/dist/distProduct/filterProduct/list',
				props: {
					label: 'abbreviation',
					value: 'type',
				},
				search: true,
			},

			{
				label: '适用产品',
				showColumn: false,
				prop: 'suitProduct',
				hide: true,
				type: 'select',
				dicUrl: `/dist/distProduct/listInfo`,
				props: {
					label: 'title',
					value: 'id',
				},
				dicFormatter: function ({data}) {
					return [{title: '全部', id: '-1'}, ...data]
				},
			},

			{
				hide: true,
				showColumn: false,
				label: '备注',
				prop: 'remark',
			},
		],
	}
}

//工种库新增修改
export const verificationDetail = (safe) => {
	return {
		border: true,
		// stripe: true,
		delBtn: false,
		addBtn: false,
		editBtn: false,
		refreshBtn: false,
		columnBtn: false,
		searchShowBtn: false,
		menuWidth: 160,
		menuAlign: 'center',
		align: 'center',

		column: [
			{
				label: '职业关键字',
				headerslot: true,
				prop: 'keyWord',
			},
			{
				label: '作业条件1',
				prop: 'condition1',
			},
			{
				label: '作业条件2',
				prop: 'condition2',
			},
			{
				label: '作业条件3',
				prop: 'condition3',
			},

			{
				label: '险种&结论&工种&适用产品&备注',
				prop: 'inReSuitWork',
				headerslot: true,
				width: 750,
			},

			{
				label: '险种',
				prop: 'insuranceId',
				headerslot: true,
				width: 160,
				hide: true,
				showColumn: false,
				type: 'select',
				dicUrl: '/dist/distProduct/filterProduct/list',
				props: {
					label: 'abbreviation',
					value: 'type',
				},
			},
			{
				label: '结论',
				prop: 'result',
				showColumn: false,
				hide: true,
				dicData: resultType,
				headerslot: true,
				width: 180,
			},
			{
				label: '工种',
				hide: true,
				showColumn: false,
				prop: 'suitWork',
				width: 180,
			},

			{
				label: '适用产品',
				hide: true,
				prop: 'suitProduct',
				width: 160,
				type: 'select',
				dicUrl: `/dist/distProduct/listInfo`,
				props: {
					label: 'title',
					value: 'id',
				},
				dicFormatter: function ({data}) {
					return [{title: '全部', id: '-1'}, ...data]
				},
			},

			// {
			//   hide:true,
			//   label: '备注',
			//   prop: 'remark'
			// }
		],
	}
}
